const { shade, tint } = require('polished');

class CorUtil {
  static rgb(cor) {
    const rgb = this.getRGB(cor);

    return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue})`;
  }

  static rgba(cor, alpha) {
    const rgb = this.getRGB(cor);

    return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, ${alpha})`;
  }

  static shade(cor, porcentagem) {
    return shade(porcentagem, cor);
  }

  static tint(cor, porcentagem) {
    return tint(porcentagem, cor);
  }

  static getRGB(cor) {
    let color = cor.toString();

    if (color.indexOf('#') === 0) {
      color = color.slice(1);
    }

    const rgb = {
      red: parseInt(color.slice(0, 2), 16),
      green: parseInt(color.slice(2, 4), 16),
      blue: parseInt(color.slice(4, 6), 16),
    };

    return rgb;
  }
}

export default CorUtil;